import { createReducer, on } from '@ngrx/store';
import { Company, PowerUser } from '@ridango/core';

import * as CompanyAction from './company.actions';

export interface CompanyNgrxState {
    all: Company[],
    selected: Company,
    powerUsers: PowerUser[],
    loaded: boolean
}

export const COMPANY_NGRX_FEATURE_KEY = 'companies';

export interface CompanyStoreState {
    readonly [COMPANY_NGRX_FEATURE_KEY]: CompanyNgrxState;
}

export const COMPANY_NGRX_INITIAL_STATE: CompanyNgrxState = {
    all: null,
    selected: null,
    powerUsers: null,
    loaded: false
}

export const companyNgrxReducer = createReducer(
    COMPANY_NGRX_INITIAL_STATE,
    on(CompanyAction.fetchAllCompanies, (state) => ({ ...state, loaded: false })),
    on(CompanyAction.fetchAllCompaniesSuccess, (state, { companies }) => ({ ...state, all: companies, loaded: true })),
    on(CompanyAction.fetchAllCompaniesFailed, (state) => ({ ...state, loaded: true })),
    on(CompanyAction.setSelectedCompany, (state, { company }) => ({ ...state, selected: company })),
    on(CompanyAction.saveCompanyProfile, (state) => ({ ...state, loaded: false })),
    on(CompanyAction.saveCompanyProfileSuccess, (state, { company }) => ({ ...state, selected: company, loaded: true })),
    on(CompanyAction.saveCompanyProfileFailed, (state) => ({ ...state, loaded: true })),
    on(CompanyAction.fetchPowerUsers, (state) => ({ ...state, loaded: false })),
    on(CompanyAction.fetchPowerUsersSuccess, (state, { powerUsers }) => ({ ...state, powerUsers: powerUsers, loaded: true })),
    on(CompanyAction.fetchPowerUsersFailed, (state) => ({ ...state, loaded: true })),
);
